// 退款申请列表-详情
export default {
    heard_title: "Refund Request",
    tab_single: "Item Order",
    tab_private: "Private Field Order",
    tab_product: "Product Order",
    // 表单
    fl_no: "Enter search:",
    fp_no: "Service ticket number",
    fl_keyword: "Contact:",
    fp_keyword: "Name/Mobile Number",
    fl_creatTime: "Refund time:",
    fp_creatTime: "Please select a time",
    // 表格
    tl_orderNo: "Order No.",
    tl_userNum: "User Account",
    tl_amount: "Refund Amount",
    tl_name: "Contact",
    tl_reason: "Reason for refund",
    tl_operator: "Operator",
    tl_applyTime: "Refund Time",

    // 退款详情
    heard_title2: "Service Order Details",
    th_refundItem: "Refund Item",
    tl_itemName: "Item Name",
    tl_shop: "Products",
    tl_scheduleCode: "Schedule",
    tl_size: "size",
    tl_orderAmount: "Price",
    tl_quantity: "Quantity",
    tl_discount: "Discount",
    tl_orderPay: "Actual Payment",

    // 服务单信息
    th_serveInfo: "Service Order Information",
    tl_orderNum: "Order Number",
    btn_view: "View",
    tl_applyDate: "Apply Date",
    tl_refundName: "Contact",
    tl_mobile: "Contact phone number",
    tl_refundReason: "Refund Reason",
    tl_refundAmount: "Refund Amount",
    tl_refundDesc: "Refund Description"
};
